export const editionMenu = function (el) {
    console.log(el);
    el.querySelectorAll("a").forEach(function (item) {
        item.href += "?menu=true";
    });
};
